import {useLocation, useNavigate} from 'react-router-dom';
import React, {useEffect, useRef, useState, useCallback} from 'react';
import styles from './Home.module.scss';
import Container from 'react-bootstrap/Container';
import {Nav} from "react-bootstrap";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Cluster from "../cluster/index.js";
import {orbitClusterTileList} from '../../actions/orbitClusterTileList.js';
import {useDispatch, useSelector} from "react-redux";
import {userProfile} from "../../actions/userProfile.js";
import {orbit} from "../../actions/orbit.js";
import {SERVICE_LINE_ADMIN, ORBIT_ADMIN, ORGANIZATION_ADMIN, REGULAR_USER, SYS_ADMIN} from "../../constants/roles.js";
import {SelectList} from "../selectList/index.js";
import {
    loadTiles, setDiagnosticValue,
    setOrganization,
    setServiceLine,
    setValue,
    userOrbitOrgPopulateAndDisplay
} from "../common/home/index.js";

import {
    setDiagnosticId,
    setDisplayDiagnostics,
    setDisplayTiles,
    setInitialTopNavDisplay,
    setTermsConditionsCompleted,
    setHideTopNav, setSelectOrbit, setDisplayOrbit
} from "../../actions/home.js";
import {getUser, setUser} from "../../helpers/index.js";
import {HOME, HOME_ERROR, PAGE_ACCESS_ERROR, UPDATE_LOGO} from "../../actions/types.js";
import {termsConditions} from "../../actions/termsConditions.js";
import {Link} from "react-router-dom";
import {orbitById} from "../../actions/orbitById.js";
import {getServiceLineList} from "../../actions/serviceLineList";
import {orgList} from "../../actions/orgList";
import {viewedOrganizationWelcomeMessage} from "../../actions/viewedOrganizationWelcomeMessage";
import {viewedOrbitWelcomeMessage} from "../../actions/viewedOrbitWelcomeMessage";
import {markUserAsRegisteredToANewOrbit} from "../../actions/markUserAsRegisteredToANewOrbit";


const Home = (props) => {
    const [profileUrl, setProfileUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingOrbit, setIsLoadingOrbit] = useState(true);
    const [isLoadingServiceLine, setIsLoadingServiceLine] = useState(true);
    const [hasLoadedTiles, setHasLoadedTiles] = useState(false);
    const [isRegularUserSettingsComplete, setIsRegularUserSettingsComplete] = useState(false);
    const [isLoadingTermsConditions, setIsLoadingTermsConditions] = useState(false);
    const [displayCluster, setDisplayCluster] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const [termsConditionsShowHide, setTermsConditionsShowHide] = useState(false);

    const {
        bodyCss
    } = useSelector(state => state.logo);


    const {
        tileAttributes,
        clusterType,
        useFlexContainer,
        diagnosticList,
        serviceLineList,
        displayDiagnostics,
        displayTiles,
        displayServiceLine,
        displayOrbit,
        defaultOrbit,
        orbitList,
        clusterCssArray,
        initialTopNavDisplay,
        serviceLineId,
        organizationId,
        organizationList,
        displayOrganization,
        orbitHome,
        viewedWelcomeMessage,
        welcomeMessage
    } = useSelector(state => state.home);


    const {
        orgImageUrl,
        favIconAttributes,
        orbitCssClass
    } = useSelector(state => state.logo);
    const dispatch = useDispatch();
    let user = getUser();
    let selectedDiagnosisId = [];

    const changeOrganization = useCallback(async (value) => {
        // Create the function that takes value as the final parameter
        debugger;
        const curriedFn = await setOrganization(dispatch)(setTermsConditionsShowHide)(user)(setDisplayCluster)(setIsLoadingServiceLine)(organizationList);

        // Now call that function with the value
        return curriedFn(value);
    }, [dispatch, user, setDisplayCluster, setIsLoadingServiceLine, organizationList]);

    const changeServiceLine = useCallback(async (value) => {
        // Create the function that takes value as the final parameter
        const freshUser = getUser();
        const curriedFn = await setServiceLine(dispatch)(serviceLineList)(setIsLoadingOrbit)(defaultOrbit)(freshUser);

        // Now call that function with the value
        return curriedFn(value);
    }, [dispatch, serviceLineList, setIsLoadingOrbit, defaultOrbit]);

    const changeOrbit = useCallback(async (value) => {
        // Create the function that takes value as the final parameter
        const freshUser = getUser();
        const curriedFn = await setValue(dispatch)(setTermsConditionsShowHide)(navigate)(location)(setHasLoadedTiles)(setIsRegularUserSettingsComplete)(isRegularUserSettingsComplete)(freshUser);

        // Now call that function with the value
        return curriedFn(value);
    }, [dispatch, navigate, location, setHasLoadedTiles, setIsRegularUserSettingsComplete, isRegularUserSettingsComplete]);

    const currentUser = () => {
        return user;
    }

    const changeTermsConditions = async (e) => {
        const orbitId = (user?.roles?.includes(ORBIT_ADMIN) || user?.roles?.includes(REGULAR_USER))
            ? user?.defaultOrbit : undefined;
        const organizationId = (user?.roles?.includes(SERVICE_LINE_ADMIN) || user?.roles?.includes(ORGANIZATION_ADMIN))
            ? user?.organizationId
            : (!orbitId ? user?.organizationId : undefined);
        const tc = await termsConditions({organizationId, orbitId}, async (data) => {
            if (data?.error)
                return;

            if (user?.orbits && user?.orbits?.length >= 1) {
                const updatedOrbits = user?.orbits.map((orbit) => {
                    if (orbit?.orbitId === user?.defaultOrbit && orbit?.organizationId === user?.organizationId) {
                        orbit.termsConditionsCompleted = true;
                    }
                    return orbit;
                })
                user.orbits = updatedOrbits;
                setUser(user);
            }

            if (user?.organizations && user?.organizations?.length >= 1) {
                const updatedOrganizations = user?.organizations.map((organization) => {
                    if (organization?.organizationId === user?.organizationId) {
                        organization.termsConditionsCompleted = true;
                    }
                    return organization;
                })
                user.organizations = updatedOrganizations;
                setUser(user);
            }

            if ((user?.orbits && user?.orbits?.length > 1) || (user?.organizations && user?.organizations?.length > 1)) {
                const mur = await markUserAsRegisteredToANewOrbit({
                    organizationId: user?.organizationId,
                    orbitId: user?.defaultOrbit
                }, (data) => {
                    if (data.success === false) {
                        dispatch({
                            type: HOME_ERROR,
                            payload: 'Unable to complete registration for the specified orbit'
                        });
                    }
                })

                await dispatch(mur);
            }

            setTermsConditionsShowHide(e.target.value === 'on' ? false : true);
        })
        await dispatch(tc);
    }

    const changeViewedWelcomeMessage = async (e) => {
        if (e.target.value === 'on') {
            if (user?.roles?.includes(SYS_ADMIN) || user?.roles?.includes(SERVICE_LINE_ADMIN) || user?.roles?.includes(ORGANIZATION_ADMIN)) {
                const tc = await viewedOrganizationWelcomeMessage({organizationId: user?.organizationId}, (data) => {
                })
                await dispatch(tc);
            } else {
                const tc = await viewedOrbitWelcomeMessage({orbitId: user?.orbitId}, (data) => {
                })
                await dispatch(tc);
            }
        }
    }

    useEffect(() => {
        if (!tileAttributes || tileAttributes.length === 0) {
            dispatch(setDisplayOrbit(false));
            dispatch(setSelectOrbit(false));
            userOrbitOrgPopulateAndDisplay(dispatch)(setTermsConditionsShowHide)(user)(organizationList)(organizationId);
        }

        if (tileAttributes && tileAttributes.length > 0) {
            setDisplayCluster(true);
        }

        if (defaultOrbit && defaultOrbit.length > 0 && (!tileAttributes || tileAttributes.length === 0)) {
            loadTiles(user)(setProfileUrl)(dispatch)({id: defaultOrbit});
            dispatch(setHideTopNav(false));
        }
    }, [defaultOrbit, tileAttributes])

    useEffect(() => {
        (async () => {
            setDisplayTiles(false);
            //userOrbitOrgPopulateAndDisplay(dispatch)(setTermsConditionsShowHide)(user)(organizationList)(organizationId);

            if (tileAttributes && tileAttributes.length > 0) {
                setDisplayCluster(true);

                if (user?.imageUrl && user?.imageUrl.length > 0)
                    setProfileUrl(user?.imageUrl);
            }

            if ((defaultOrbit && defaultOrbit.length > 0) ||
                (user?.defaultOrbit && user?.defaultOrbit.length > 0)) {
                dispatch(setHideTopNav(false));
            } else {
                dispatch(setHideTopNav(true));
            }
        })()
    }, [])

    useEffect(() => {
        (async () => {
            if (orbitHome) {
                dispatch(setSelectOrbit(false));
                userOrbitOrgPopulateAndDisplay(dispatch)(setTermsConditionsShowHide)(user)(organizationList)(organizationId);

                if (tileAttributes && tileAttributes.length > 0) {
                    setDisplayCluster(true);
                }

                if ((defaultOrbit && defaultOrbit.length > 0) ||
                    (user?.defaultOrbit && user?.defaultOrbit.length > 0)) {
                    dispatch(setHideTopNav(false));
                } else {
                    dispatch(setHideTopNav(true));
                }
            }

            if (user?.isSysAdmin || user?.roles?.includes(SERVICE_LINE_ADMIN))
                setTermsConditionsShowHide(false);
        })()
    })


    return (
        <div className="w-100 authTrue">
            <div className="w-100">
                {(!viewedWelcomeMessage && welcomeMessage && welcomeMessage.length > 0) &&
                    <div className="termsContainer">
                        <div className="termsOverlay">
                            <div className="w-100">
                                <Container>
                                    <div className="termsContent">
                                        <div className="text-dark">
                                            {welcomeMessage}
                                        </div>
                                        <FormGroup>
                                            <FormControlLabel className="text-dark" control={<Checkbox/>} label="Close this message."
                                                              onChange={changeViewedWelcomeMessage}/>
                                        </FormGroup>
                                    </div>
                                </Container>
                            </div>
                        </div>
                    </div>
                }
                {termsConditionsShowHide &&
                    <div className="termsContainer">
                        <div className="termsOverlay">
                            <div className="w-100">
                                <Container>
                                    <div className="termsContent">
                                        <h1 className="text-dark">Welcome!</h1>
                                        <h2 className="text-dark">Since this is your first visit, please agree to the terms and conditions.</h2>
                                        <div className="terms">
                                            <p>This {currentUser()?.orbitNameForTermsConditions} is for your information and education only. Using this program does not take the place of conversations between you and your healthcare provider. This program gives general information about how some health problems may be treated. This information is extra education in addition to your appointments with your healthcare provider. This {currentUser()?.orbitNameForTermsConditions} is meant to educate you about medical conditions and treatments, but it does not cover everything. No guarantees or warranties are made about the treatment. This {currentUser()?.orbitNameForTermsConditions} is not meant to give exact medical advice to anyone. And it does not replace the informed consent process you will go through with your healthcare provider. Please talk with your healthcare provider about any questions or concerns you have about the information in this program.</p>
                                            <p>This CareOrbit&reg; program is for your information and education only. Using this program does not take the place of conversations between you and your healthcare provider. This program gives general information about how some health problems may be treated. This information is extra education in addition to your appointments with your healthcare provider. This CareOrbit program is meant to educate you about medical conditions and/or surgical procedures, but it does not cover everything. This program may go over the most common possible risks and complications of medical treatments or surgical procedures. But there may be other problems, known and unknown, that can happen after treatment or surgery. No guarantees or warranties are made about the treatment or surgery itself. This CareOrbit program is not meant to give exact medical or surgical advice to anyone. And it does not replace the informed consent process you will go through with your healthcare provider. Please talk with your healthcare provider about any questions or concerns you have about the information in this program. Also talk with your healthcare provider in person about what kinds of problems you may have if you do not have this treatment.</p>
                                            <p>Additional terms and conditions covering your use of the CareOrbit program are located at <Link target="_blank" to="terms-of-use">Terms Of Use</Link>, which are incorporated herein by reference.</p>
                                            <p>By clicking the box below, you acknowledge and accept the terms outlined above.</p>



                                        </div>
                                        <FormGroup>
                                            <FormControlLabel className="text-dark" control={<Checkbox/>} label=" I agree to the Terms and Conditions."
                                                              onChange={changeTermsConditions}/>
                                        </FormGroup>
                                    </div>
                                </Container>
                            </div>
                        </div>
                    </div>
                }
                {!termsConditionsShowHide &&
                    <Container>
                        {(!initialTopNavDisplay && !displayTiles && displayOrganization) && (organizationList && organizationList?.length > 0) && (!organizationId || organizationId.length === 0) && (
                            <SelectList list={organizationList} setSelectedValue={changeOrganization}
                                        labels={{text: 'orgName', value: 'organizationId'}}
                                        heading="Select an Organization to View:"/>)}
                        {(!initialTopNavDisplay && !displayTiles && !displayDiagnostics && !displayOrganization && displayServiceLine) && (serviceLineList && serviceLineList?.length > 0) && (!serviceLineId || serviceLineId.length === 0) && (
                            <SelectList list={serviceLineList} setSelectedValue={changeServiceLine}
                                        labels={{text: 'name', value: 'serviceLineId'}}
                                        heading="Select an service line to view:"/>)}
                        {(!initialTopNavDisplay && !displayTiles && !displayDiagnostics && !displayOrganization && !displayServiceLine && displayOrbit) && (orbitList && orbitList?.length > 0) && (<SelectList list={orbitList} setSelectedValue={changeOrbit}
                                        labels={{text: 'orbitName', value: 'orbitId', subheading: 'orgName'}}
                                        heading="Select an Orbit Guide to View:"/>)}
                        {!initialTopNavDisplay && displayDiagnostics && (diagnosticList && diagnosticList?.length > 0) && (
                            <SelectList list={diagnosticList} setSelectedValue={setDiagnosticValue(dispatch)}
                                        labels={{text: 'name', value: 'diagnosisId'}}
                                        heading="Select a diagnosis to view:"/>)}
                        {((displayTiles || !isLoading) && !displayDiagnostics &&
                        displayCluster && (tileAttributes && tileAttributes?.length > 0) ?
                            <Cluster
                                clusterType={clusterType}
                                useFlexContainer={useFlexContainer}
                                tileAttributes={tileAttributes}
                                profileUrl={profileUrl}
                                dIdList={user?.diagnoses}
                                clusterCssArray={clusterCssArray}
                                tileClickable={!user?.isTemporaryOrbitAccessUser}
                                key="homeCluster"
                            /> : (!isLoadingOrbit &&
                                ((!user?.orbits || user?.orbits?.length === 0) &&
                                    (!user?.organizations || user?.organizations?.length === 0) &&
                                    !user?.isSysAdmin ?
                                <div className="notFoundContainer" key="notFoundContainer">
                                    <h1>
                                        The assigned orbit is under construction and will be released as soon as possible.
                                        Please feel free to try again later as
                                        we will continue to add valuable information.
                                    </h1>
                                </div> : '')))}
                    </Container>
                }
            </div>
        </div>
    )
};

export default Home;
